import { render, staticRenderFns } from "./DisclosurePage.html?vue&type=template&id=6af30b05&scoped=true&"
import script from "./DisclosurePage.js?vue&type=script&lang=js&"
export * from "./DisclosurePage.js?vue&type=script&lang=js&"
import style0 from "./DisclosurePage.scss?vue&type=style&index=0&id=6af30b05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af30b05",
  null
  
)

export default component.exports